export { default } from './CouponsAccordion'
